import { forwardRef } from "react";
import type { BeaconRenderProps } from "react-joyride";

export const TourBeacon = forwardRef<HTMLButtonElement, BeaconRenderProps>(
  (props, ref) => (
    <button
      ref={ref}
      type="button"
      {...props}
      className="relative h-9 w-9 rounded-full bg-(--color-action)/20"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-(--color-action)/40" />
      <span className="absolute inset-1 rounded-full bg-(--color-action)" />
    </button>
  ),
);

TourBeacon.displayName = "TourBeacon";
